/**
 * Remove tabindex from GF fields.
 *
 * @link https://dequeuniversity.com/rules/axe/4.9/tabindex
 */
const removeTabIndex = () => {
  const gfTabIndex = document.querySelectorAll<HTMLElement>( '.gfield-choice-input, button' )
  if ( gfTabIndex ) {
    gfTabIndex.forEach( element => {
      element.tabIndex = 0
    } )
  }
}

export default removeTabIndex